// Campo obrigatório.
export const required = value => value ? undefined : 'Campo obrigatório';

// Número máximo de caracteres.
export const maxLength = max => value => value && value.length > max ? `Must be ${max} characters or less` : undefined;

// Número mínimo de caracteres.
const minValue = min => value => value && value < min ? `Must be at least ${min}` : undefined;
export const minValue5 = minValue(5);

// Campo númerico.
export const number = value => value && isNaN(Number(value)) ? 'Campo deve ser numerico' : undefined;

// Campo do tipo e-mail.
export const email = value => value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'Endereço de e-mail inválido' : undefined;

function age(d1, d2) {
  d2 = d2 || new Date();

  const diff = d2.getTime() - d1.getTime();

  return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
}

// MaxAgePet
export const maxAgePet = max => {
  const birth = age(new Date(max.substring(4), max.substring(2, 4), max.substring(0, 2)));

  return birth > 8 ? 'Idade do pet não pode ser superior a 8 (oito) anos.' : undefined;
};